import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken, setToken } from '@/utils/auth'
import router from '@/router'

// create an axios instance（恢复为最初配置：固定使用 VUE_APP_BASE_API）
const service = axios.create({
  // 开发环境通过 devServer 代理 `/api`，避免跨域导致的验证码/session 不一致
  baseURL: process.env.NODE_ENV === 'development' ? '' : (process.env.VUE_APP_BASE_API || ''), // url = base url + request url
  timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    const token = getToken()

    if (token) {
      // let each request carry token
      // 尝试不同的token头格式
      config.headers['token'] = token
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    const silent = response.config && response.config.silentError
    // 根据智蜂智造API的响应格式
    if (res.code === 0) {
      // code为0表示错误
      if (!silent) {
        Message({
          message: res.msg || 'Error',
          type: 'error',
          duration: 5 * 1000
        })
      }
      return Promise.reject(new Error(res.msg || 'Error'))
    } else if (res.code === 202) {
      // code为202需要缓存token并跳转到账号类型选择页面
      if (res.data && res.data.token) {
        // 通过 Vuex store 缓存token
        setToken(res.data.token)
        // 跳转到账号类型选择页面
        setTimeout(() => {
          router.push('/type')
        }, 100)
      }
      return res
    } else if (res.code === 203) {
      // code为203表示需要提示的错误
      if (!silent) {
        Message({
          message: res.msg || '操作失败，请重试',
          type: 'error',
          duration: 5 * 1000
        })
      }
      return Promise.reject(new Error(res.msg || '操作失败'))
    } else if (res.code === 1) {
      // code为1表示成功
      return res
    } else {
      // 其他情况，可能是token相关错误
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        // to re-login
        MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
          confirmButtonText: 'Re-Login',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          store.dispatch('user/resetToken').then(() => {
            location.reload()
          })
        })
      } else if (res.msg) {
        // 如果有错误消息，显示提示
        if (!silent) {
          Message({
            message: res.msg,
            type: 'error',
            duration: 5 * 1000
          })
        }
      }
      return Promise.reject(new Error(res.msg || '请求失败'))
    }
  },
  error => {
    console.log('err' + error) // for debug

    const cfg = error.config
    if (!cfg || !cfg.silentError) {
      Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      })
    }
    return Promise.reject(error)
  }
)

export default service
